import { Grid, Typography } from "@mui/material";
import React from "react";

import PercentageStat from "../PercentageStat";
import { convertNumberToCommaSeparatedFormat } from "utils/string";

const PatientComplianceAnalyticStat = ({ data, schedule }) => {
  const scheduleSubString = schedule === "day_31" ? "Day31" : "Day91";
  return (
    <Grid container flex={1} alignItems="center" justifyContent="space-between">
      <Grid item>
        <Typography
          variant="h5"
          style={{ fontWeight: 700, display: "flex", alignItems: "center" }}
        >
          {convertNumberToCommaSeparatedFormat(
            data?.[`currentMonthTotalCount${scheduleSubString}`]
          ) ?? 0}

          {convertNumberToCommaSeparatedFormat}
          <Typography
            style={{ color: "#757575", fontSize: "14px", marginLeft: "4px" }}
          >
            in current month
          </Typography>
        </Typography>
        <Typography paragraph style={{ color: "#757575", fontSize: "14px" }}>
          {convertNumberToCommaSeparatedFormat(
            data?.[`previousMonthTotalCount${scheduleSubString}`]
          ) ?? 0}{" "}
          in last month
        </Typography>
      </Grid>
      <Grid item>
        <PercentageStat
          value={data?.[`differencePercentage${scheduleSubString}`]}
        />

        <Typography paragraph style={{ color: "#757575", fontSize: "14px" }}>
          vs last month
        </Typography>
      </Grid>
    </Grid>
  );
};

export default PatientComplianceAnalyticStat;
